import { FloatingPosition, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { ReactNode } from 'react';

export const InfoTooltip = ({ label, position }: { label: ReactNode; position?: FloatingPosition | undefined }) => {
  return (
    <Tooltip label={label} position={position} multiline withArrow className="max-w-[400px]">
      <span>
        <IconInfoCircle size={16} className="text-gray-500" />
      </span>
    </Tooltip>
  );
};
